import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * roles: ['admin', 'common']       // 访问路由的角色权限
 * permissions: ['a:a:a', 'b:b:b']  // 访问路由的菜单权限
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置屑中该路由在侧边栏和面包展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */
const service = axios.create({
  baseURL: "/",
  timeout: 30000,
  withCredentials: true // 这一行必须存在！！携带Session Cookie
})

// 公共路由
export const constantRoutes = [
  {
    path: '/',
    redirect: '/indexNew',
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
// {
//   path: '/airwayZdmanage',
//   children: [
//   // 所有 Thymeleaf 旧页面通过 iframe 加载
//   {
//     path: 'legacy/:pathMatch(.*)*',
//     name: 'airwayZdmanage',
//     component: () => import('@/views/airwayZdmanage/init.vue'),
//   meta: {
//   title: '航线主单管理',
//     isLegacy: true  // 标记为旧页面
// }
// }
// ]
// },
  {
    path: '/lginindex',
    component: () => import('@/views/login'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
{
  path: '/indexNew',
  component: Layout,
  children: [
  {
    path: '',
    component: () => import('@/views/index'),
  meta: { title: '首页', icon: 'dashboard', affix: true }
}
]
},
  // ==================== Vue 版本用户管理示例（使用旧接口，Vue 新页面） ====================
  {
    path: '/system/user-vue',
    component: Layout,
    meta: { title: '用户管理(Vue)', icon: 'user' },
    children: [
      {
        path: '',
        component: () => import('@/views/system/user/index'),
        name: 'SystemUserVue',
        meta: { title: '用户管理(Vue)', icon: 'user' }
      }
    ]
  },
  {
    path: '/ads',
    component: Layout,
    redirect: 'noRedirect',
    alwaysShow: true,
    meta: { title: '航线操作管理', icon: 'nested' },
    children: [
      {
        path: 'adsFollowPerson',
        component: () => import('@/views/ads/adsFollowPerson/index'),
        name: 'AdsFollowPerson',
        meta: { title: '客服管理', icon: 'peoples' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  }
// {
//   path: '',
//     component: Layout,
//   hidden: true,
//   children: [
//   {
//     path: 'orderManagement',
//     component: () => import('@/views/order/management/index'),
//   name: 'OrderManagement',
//   meta: { title: '订单管理', icon: 'user'}
// }
// ]
// },
// {
//   path: '',
//     component: Layout,
//   hidden: true,
//   children: [
//   {
//     path: 'ccordersOrders',
//     component: () => import('@/views/ccorders/orders/index'),
//   name: 'ccordersOrders',
//   meta: { title: '订单管理', icon: 'user'}
// }
// ]
// }
]


// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  {
    path: '/system/user-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:user:edit'],
    children: [
      {
        path: 'role/:userId(\\d+)',
        component: () => import('@/views/system/user/authRole'),
        name: 'AuthRole',
        meta: { title: '分配角色', activeMenu: '/system/user' }
      }
    ]
  },
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:edit'],
    children: [
      {
        path: 'user/:roleId(\\d+)',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户', activeMenu: '/system/role' }
      }
    ]
  },
  {
    path: '/system/dict-data',
    component: Layout,
    hidden: true,
    permissions: ['system:dict:list'],
    children: [
      {
        path: 'index/:dictId(\\d+)',
        component: () => import('@/views/system/dict/data'),
        name: 'Data',
        meta: { title: '字典数据', activeMenu: '/system/dict' }
      }
    ]
  },
// {
//   path: '/ccorders/orders-printFullContainerList',
//   component: Layout,
//   hidden: true,
//   permissions:['ccorders:orders:list'],
//   children: [
//   {
//     path: 'index',
//     component: () => import('@/views/ccorders/orders/printFullContainerList'),
//   name: 'PrintFullContainerList',
//   meta: { title: '打印整柜清单', activeMenu: '/ccorders/orders' }
// }
// ]
// },
// {
//   path: '/kefu/order-orderView',
//   component: Layout,
//   hidden: true,
//   permissions: ['kefu:order:list'],
//   children: [
//   {
//     path: 'index/:orderId(\\d+)',
//     component: () => import('@/views/kefu/order/orderView'),
//   name: 'OrderView',
//   meta: { title: '订单详情', activeMenu: '/kefu/order' }
// }
// ]
// },
//   {
//     path: '/monitor/job-log',
//     component: Layout,
//     hidden: true,
//     permissions: ['monitor:job:list'],
//     children: [
//       {
//         path: 'index/:jobId(\\d+)',
//         component: () => import('@/views/monitor/job/log'),
//         name: 'JobLog',
//         meta: { title: '调度日志', activeMenu: '/monitor/job' }
//       }
//     ]
//   },
  {
    path: '/tool/gen-edit',
    component: Layout,
    hidden: true,
    permissions: ['tool:gen:edit'],
    children: [
      {
        path: 'index/:tableId(\\d+)',
        component: () => import('@/views/tool/gen/editTable'),
        name: 'GenEdit',
        meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
      }
    ]
  }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
